import React, { useEffect, useRef } from 'react';
import AdvisoryBoardCarousel from '../../component/common/advisory'
import MediaCarousel from '../../component/common/media'
import FooterHero from '../../component/common/CTA'
import { FaArrowRightLong, FaArrowRight } from "react-icons/fa6";
import gsap from "gsap";

const boardMembers = [
    {
        img: "img/advisory/ashish.png",
        name: "Ashish Mittal",
        position: "Founder & Chief Mentor",
        link: "https://linkedin.com/in/example1",
    },
    {
        img: "img/advisory/vivek.jpg",
        name: "Vivek Srivastava",
        position: "HealthTech Advisor",
        link: "https://linkedin.com/in/example2",
    },
    {
        img: "img/advisory/prashant.jpg",
        name: "Prashant Lohia",
        position: "RetailTech Advisor",
        link: "https://linkedin.com/in/example3",
    },
    {
        img: "img/advisory/gagan.jpg",
        name: "Gagan Jain",
        position: "SaaSTech Advisor",
        link: "https://www.linkedin.com/in/gaganmsjain/",
    },
    {
        img: "img/advisory/vikas.jpg",
        name: "Vikas Chowdhary",
        position: "Fintech Advisor",
        link: "https://www.linkedin.com/in/vikaschaudhary-6equj5/",
    },
    {
        img: "https://picsum.photos/600/600",
        name: "Dr. V Gopal",
        position: "Edtech Advisor",
        link: "https://www.linkedin.com/in/dr-v-gopal-5a6082a/",
    },
];

const mediaData = [
    {
        title: "Student housing Startup Your-space raises Angel Funding",
        date: "January 2025",
        link: "https://www.vccircle.com/exclusive-student-housing-startup-your-space-raises-angel-funding",
    },
    {
        title: "TurningIdeas Venture to help startups with early investments",
        date: "February 2025",
        link: "https://economictimes.indiatimes.com/small-biz/money/turningideas-venture-to-help-startups-with-early-investments/articleshow/52863561.cms",
    },
    {
        title: "42 per cent of Indian Startups Plan to Go Global",
        date: "January 2025",
        link: "https://www.business-standard.com/content/press-releases-ani/42-per-cent-of-indian-startups-plan-to-go-global-in-2022-turningideas-survey-121121601096_1.html",
    },
];

const AboutPage = () => {
    const offerSectionRef = useRef(null);
    const offerHeadingRef = useRef(null);
    const offerCardRefs = useRef([]);
    const offerAnimationTriggered = useRef(false);


    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !offerAnimationTriggered.current) {
                        offerAnimationTriggered.current = true;
                        animateOfferSection();
                        if (offerSectionRef.current) {
                            observer.unobserve(offerSectionRef.current);
                        }
                    }
                });
            },
            {
                threshold: 0.2,
            }
        );

        const currentRef = offerSectionRef.current; // Capture the ref value

        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, []);

    const animateOfferSection = () => {
        const heading = offerHeadingRef.current;
        const cards = offerCardRefs.current;

        const tl = gsap.timeline({ defaults: { duration: 0.8, ease: "power2.out" } });

        tl.fromTo(heading, {
            yPercent: -20,
            opacity: 0,
        }, {
            yPercent: 0,
            opacity: 1,
        });

        tl.fromTo(
            cards,
            {
                yPercent: 20,
                opacity: 0,
            },
            {
                yPercent: 0,
                opacity: 1,
                stagger: 0.15,
            },
            "-=0.5"
        );
    };


    return (
        <div>
            <section className="bg-blue-600 text-white py-8 md:py-20 px-8 text-center relative bg-cover bg-no-repeat bg-center" style={{ backgroundImage: `url('/img/about-bg.png')` }}>
                <div className="max-w-4xl mx-auto h-96 flex flex-col justify-center items-center">
                    <p className="mb-4 text-3xl">About Us</p>
                    <h1 className="text-4xl md:text-6xl mb-6">
                        How We Help<br />
                        <span className='font-bold'>Startups Scale Faster</span>
                    </h1>

                    <a href="https://forms.gle/hRT1f96s5cWEg16U8" target="_blank" rel="noopener noreferrer">
                        <button className="bg-orange-600 hover:bg-orange-700 text-white py-3 px-8 text-lg rounded-full flex items-center mx-auto">
                            Partner with us <FaArrowRight className='ml-2' />
                        </button>
                    </a>


                </div>
            </section>

            {/* Main Content */}
            <section className="max-w-7xl mx-auto py-12 md:py-24 px-6 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-12">
                {/* Left Column */}
                <div>
                    <h2 className="text-4xl md:text-5xl leading-tight mb-4 text-black">Who We Are</h2>
                    <p className="mb-2 text-lg md:text-xl leading-relaxed font-light">Turning ideas into <span className='font-medium'>startup studios</span> that goes beyond funding. We actively <span className='font-medium'> co-build, validate, and scale startups </span> by providing hands-on  <span className='font-medium'> strategy, sales, and product development support.</span>
                    </p>

                    <div className="mt-8">
                        <img
                            src="img/mission.png"
                            alt="Digital transformation concept"
                            className=" h-72 w-full"
                        />
                    </div>
                </div>

                {/* Right Column */}
                <div className="flex flex-col">
                    <div className="mb-8">
                        <div className="flex justify-between items-center border-b p-4">
                            <h3 className="text-lg font-medium">Our Portfolio</h3>
                            <FaArrowRightLong />           </div>

                        <div className="flex justify-between items-center border-b p-4">
                            <h3 className="text-lg font-medium">Our Team</h3>
                            <FaArrowRightLong />                 </div>

                        <div className="flex justify-between items-center border-b p-4">
                            <h3 className="text-lg font-medium">Our News</h3>
                            <FaArrowRightLong />                 </div>
                    </div>

                    <div className="mt-auto">
                        <h2 className="text-4xl md:text-5xl leading-tight mb-4 text-black">Our Mission</h2>
                        <p className="mb-2 text-lg md:text-xl leading-relaxed font-light">
                            To <span className='font-medium'>empower global and Indian startups</span> by providing the right market insights, partnerships, and execution strategies for  <span className='font-medium'>rapid growth in India and Asia.</span>
                        </p>
                    </div>
                </div>
            </section>

            {/* What We Offer Section */}
            <section ref={offerSectionRef} className="py-6 md:py-12 px-6 max-w-5xl mx-auto ">
                <h2 ref={offerHeadingRef} className="text-4xl md:text-5xl leading-tight md:mb-10 mb-6 text-center text-black">What We Offer</h2>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div ref={(el) => (offerCardRefs.current[0] = el)} className="bg-orange-600 text-white md:p-16 p-8 rounded-lg h-96 text-left flex flex-col justify-center"> {/* Added flex flex-col justify-center */}
                        <h3 className="text-4xl font-medium mb-6">Co-Creation & Validation</h3>
                        <p className='font-medium text-xl'>Helping startups refine their ideas and build working innovations.</p>
                    </div>

                    <div ref={(el) => (offerCardRefs.current[1] = el)} className="bg-gray-700 text-white md:p-16 p-8 rounded-lg h-96 text-left flex flex-col justify-center"> {/* Added flex flex-col justify-center */}
                        <h3 className="text-4xl font-medium mb-6">Go-to-Market (GTM) & Sales Execution</h3>
                        <p className='font-medium text-xl'>Connecting startups with enterprises & customers.</p>
                    </div>

                    <div ref={(el) => (offerCardRefs.current[2] = el)} className="bg-blue-600 text-white md:p-16 p-8 rounded-lg h-96 text-left flex flex-col justify-center"> {/* Added flex flex-col justify-center */}
                        <h3 className="text-4xl font-medium mb-6">Regulatory & Market Entry Support</h3>
                        <p className='font-medium text-xl'>Making expansion seamless for global startups.</p>
                    </div>

                    <div ref={(el) => (offerCardRefs.current[3] = el)} className="bg-blue-900 text-white md:p-16 p-8 rounded-lg h-96 text-left flex flex-col justify-center"> {/* Added flex flex-col justify-center */}
                        <h3 className="text-4xl font-medium mb-6">Enterprise Partnerships</h3>
                        <p className='font-medium text-xl'>Bridging the gap between corporations and startups for innovation.</p>
                    </div>
                </div>
            </section>

            {/* Stats Section */}
            <section className="py-6 md:py-8 px-6 max-w-5xl mx-auto">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
                    <div>
                        <h3 className="text-3xl font-bold">60+</h3>
                        <p className="text-gray-600">Companies</p>
                    </div>

                    <div>
                        <h3 className="text-3xl font-bold">$500M+</h3>
                        <p className="text-gray-600">Follow on investment</p>
                    </div>

                    <div>
                        <h3 className="text-3xl font-bold">8</h3>
                        <p className="text-gray-600">Businesses acquired</p>
                    </div>

                    <div>
                        <h3 className="text-3xl font-bold">$1.3B+</h3>
                        <p className="text-gray-600">Portfolio Companies Acquired</p>
                    </div>
                </div>
            </section>

            <section className="py-6 md:py-12">
                <div className="container mx-auto px-6 md:px-12">
                    <AdvisoryBoardCarousel members={boardMembers} />
                </div>
            </section>

            <section className="py-6 md:py-12 bg-black">
                <div className="container mx-auto px-6 md:px-12">
                    <MediaCarousel mediaItems={mediaData} />
                </div>
            </section>


            <FooterHero
                heading="Let’s Build Together"
                subheading="Join the TurningIdeas Ecosystem"
                paragraph="Whether you're a startup, investor, or enterprise, we help you scale, innovate, and succeed."
                buttonText="Contact Us Today!"
            />
        </div>
    );
};

export default AboutPage;